import { render, staticRenderFns } from "./ChangeAssignmentContent.vue?vue&type=template&id=750bb45a"
import script from "./ChangeAssignmentContent.vue?vue&type=script&lang=js"
export * from "./ChangeAssignmentContent.vue?vue&type=script&lang=js"
import style0 from "./ChangeAssignmentContent.vue?vue&type=style&index=0&id=750bb45a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports